import { ButtonPosition, ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
import { CnMessage } from '@cainiaofe/cn-ui';
import { ActionRunEnv } from '@/common/util/action-run-env';
import { calculateTextExprValue, getRealizeValue, isArrayNotEmpty, } from '@/common/util/util';
import isNumber from 'lodash/isNumber';
import findLastIndex from 'lodash/findLastIndex';
import isPlainObject from 'lodash/isPlainObject';
export const config = {
    value: 'message',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, urlParamsDataSource, state, recordDataSource, actionRunEnv, getFlowActionInfo, position, } = config || {};
        let { response = {} } = config || {};
        if (ActionRunEnv.flowAction === actionRunEnv) {
            const flowInfo = getFlowActionInfo?.();
            const { flowList, currentFlowIndex } = flowInfo || {};
            if (isArrayNotEmpty(flowList) && currentFlowIndex) {
                const realIndex = +currentFlowIndex;
                if (isNumber(realIndex) && !isNaN(realIndex)) {
                    const beforeList = flowList.slice(0, realIndex);
                    let path = 'request';
                    const lastRequestIndex = findLastIndex(beforeList, (item) => {
                        if (item?.optType === 'request') {
                            return true;
                        }
                        else if (item?.optType === 'remove') {
                            path = 'remove';
                            return true;
                        }
                        else if (item?.optType === 'submit') {
                            path = 'submit';
                            return true;
                        }
                        return false;
                    });
                    if (lastRequestIndex !== 0) {
                        path += lastRequestIndex;
                    }
                    const realResponse = state?.valueOf?.[path];
                    if (isPlainObject(realResponse)) {
                        response = realResponse;
                    }
                }
            }
        }
        const msg = response?.msg;
        const { options = {} } = buttonConfig || {};
        const { type, title, content, ...rest } = options;
        let realContent = content;
        const realType = calculateTextExprValue(type, {
            urlParamsDataSource,
            recordDataSource: getRealizeValue(recordDataSource),
            state,
        }) || 'success';
        if (typeof content === 'function') {
            let realFirstParam = response;
            if ([
                ButtonPosition.formItemEvent,
                ButtonPosition.formDialogItemEvent,
            ].includes(position)) {
                realFirstParam = getRealizeValue(recordDataSource);
            }
            realContent = content(realFirstParam, state);
        }
        if (!realContent && !title) {
            realContent = msg;
        }
        CnMessage?.[realType]?.({ title, content: realContent, ...rest });
    },
};
